import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FilterMatchMode } from 'primereact/api';
import { Dialog } from 'primereact/dialog';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import AddEditManageStudentPhoto from './AddEditManageStudentPhoto';
import moment from 'moment';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import Toast from '../../Shared/Toast/Toast';
import { Tooltip } from 'primereact/tooltip';

const ManageStudentPhotos = () => {
    const { catchResponse } = useCatchResponse();
    const [manageStudentList, setManageStudentList] = useState([]);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Class: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [visual, setVisual] = useState(false);
    const [editData, setEditData] = useState({});
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [deleteId, setDeleteId] = useState('');

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetManagePhotoList(loginData?._id);
    }, []);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    const GetManagePhotoList = async (id) => {
        try {
            let data = {
                UserId: id,
            }
            Loader.show();
            await api.post(APIConstant.path.getStudentPhotoManageList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setManageStudentList(res?.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const actionBodyTemplate = (rows) => {
        return (
            <React.Fragment>
                <div className='p-d-flex p-ai-center p-jc-end'>
                    <Button icon="pi pi-pencil" className="e-sction-btn p-m-1" onClick={() => {
                        setVisual(true);
                        setEditData(rows)
                    }} data-pr-tooltip='Optional Subjects' tooltip={"View"} tooltipOptions={{ className: 'bluegray-tooltip', position: 'top' }} />
                    <Button icon="pi pi-trash" className="e-sction-btn p-m-0 p-m-2" onClick={(e) => {
                        setIsDeleteConfirmation(true);
                        setDeleteId(rows._id);
                    }} />
                </div>
            </React.Fragment>
        );
    };

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const onCancel = () => {
        setVisual(false);
        setEditData({});
        GetManagePhotoList(securityUserID);
    }

    const classBodyTemplate = (rowData) => {
        const fullClassName = rowData.FullClassName || '';
        const classes = fullClassName.split(',').map(c => c.trim()).filter(Boolean);
        if (classes.length <= 3) {
            return <span>{fullClassName}</span>;
        }
        const displayed = classes.slice(0, 3).join(', ');
        const uniqueClass = `class-tooltip-${rowData._id}`;
        return (
            <>
                <span className={uniqueClass} data-pr-tooltip={fullClassName} style={{ cursor: 'pointer' }}>
                    {displayed}, ...
                </span>
                <Tooltip target={`.${uniqueClass}`} position="top" style={{ maxWidth: '300px' }} />
            </>
        );
    };

    const dateBodyTemplate = (rows, type) => {
        return (
            <div>{moment(rows[type]).format("DD-MM-YYYY")}</div>
        );
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={(e) => DeleteConfig()}
            />
        </div>
    );

    const DeleteConfig = async () => {
        try {
            let data = {
                id: deleteId
            }
            await api.post(APIConstant.path.DeleteManageStudentPhotos, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Deleted successfully' });
                    setDeleteId('');
                    GetManagePhotoList(securityUserID);
                }
                handleClose();
            }).catch(err => {
                Loader.hide();
                setDeleteId('');
                handleClose();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    return (
        <div className='wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-user-plus"></i>
                    <h2>Manage Students</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                    <Button icon="pi pi-plus" className="e-h-btn" onClick={() => setVisual(true)} />
                </div>
            </div>
            <DataTable
                value={manageStudentList}
                paginator
                rows={rows}
                first={first}
                filters={filters}
                filterDisplay="menu"
                responsiveLayout="scroll"
                paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                rowsPerPageOptions={[5, 10, 20]}
                currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                onPage={onPageChange}
                className='custom-table'
                scrollHeight='calc(100vh - 120px)'
                size='small'
                tableStyle={{ tableLayout: 'fixed' }}
            >
                <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." style={{ width: '5%' }} />
                <Column
                    field="FullClassName"
                    header="Class"
                    body={classBodyTemplate}
                    style={{ width: '50%' }}
                />
                <Column
                    field="AuthorityName"
                    header="Authority"
                />
                <Column
                    field="EditMode"
                    header="Edit Mode"
                    body={(rowData) => rowData?.EditMode === 'FullProfile' ? 'Full Profile' : 'Photo Only'}
                />
                <Column field="StartDate" header="StartDate" body={(rowData) => dateBodyTemplate(rowData, 'StartDate')} />
                <Column field="EndDate" header="End Date" body={(rowData) => dateBodyTemplate(rowData, 'EndDate')} />
                <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: 'auto', textAlign: 'end' }} />
            </DataTable>
            <Dialog
                header={editData?._id ? 'Edit Manage Students' : 'Add Manage Students'}
                visible={visual}
                onHide={() => onCancel()}
                draggable={false}
                position="center"
                style={{ width: "50vw" }}
                contentStyle={{ overflow: 'hidden' }}
            >
                <AddEditManageStudentPhoto onCancel={onCancel} EditData={editData} />
            </Dialog>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
        </div>
    );
};

export default ManageStudentPhotos;
